<template>
  <button
    :class="btnClassName"
    :disabled="disabled"
    @click="onClick"
    :aria-label="ariaLabel"
    :aria-pressed="ariaPressed"
  >
    <i v-if="showIcon" :class="iconClassName"></i>
    <span v-if="showText" :class="textClassName">{{ text }}</span>
  </button>
</template>
<script>
export default {
  props: {
    btnClassName: {
      type: String
    },
    iconClassName: {
      type: String
    },
    textClassName: {
      type: String
    },
    onClick: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showText: {
      type: Boolean,
      default: false
    },
    text: {
      type: String
    },
    ariaLabel: {
      type: String
    },
    ariaPressed: {
      type: Boolean
    }
  }
};
</script>

<style scoped lang="scss">
button {
  border: none;
  background-color: transparent;
  height: 35px;
  width: 100%;
}
span {
  font-weight: bold;
}
.off span {
  color: white;
}
</style>
